import { Check, Copy, Info, Spline } from "lucide-react";

export function ActionMenu({
  handleMarkCompleted,
  handleDuplicateTask,
  addDependencyHandler,
  handleTaskModal,
  taskStatus,
  isReadOnly = false,
}) {
  return (
    <div className="bg-white rounded-lg shadow-lg border border-gray-200 overflow-hidden mt-1 w-full">
      <div className="flex flex-col">
        <button
          className="flex items-center py-1 px-3 hover:bg-gray-100 border-b border-gray-200 transition-colors"
          onClick={handleTaskModal}
        >
          <Info className="w-4 h-4 mr-2 text-gray-600" color="#342c82" />
          <span className="text-sm text-[#342c82]">View details</span>
        </button>
        {
          !isReadOnly && (
            <>
              <button
                className="flex items-center py-1 px-3 hover:bg-gray-100 border-b border-gray-200 transition-colors"
                onClick={handleDuplicateTask}
              >
                <Copy className="w-4 h-4 mr-2 text-gray-600" color="#342c82" />
                <span className="text-sm text-[#342c82]">Duplicate</span>
              </button>
              {
                taskStatus != 3 &&
                (
                  <button
                    className="flex items-center py-1 px-3 hover:bg-gray-100 border-b border-gray-200 transition-colors"
                    onClick={handleMarkCompleted}
                  >
                    <Check className="w-4 h-4 mr-2 text-gray-600" color="#342c82" />
                    <span className="text-sm text-[#342c82]">Mark as completed</span>
                  </button>
                )
              }
              {/* <button
          className="flex items-center py-1 px-3 hover:bg-gray-100 transition-colors"
          onClick={addDependencyHandler}
        >
          <Spline className="w-4 h-4 mr-2 text-gray-600"/>
          <span className="text-sm text-[#342c82]">Add dependencies</span>
        </button> */}
            </>
          )
        }

      </div>
    </div>
  );
}
